import api from './axios';

/* ══════════════════════════════════════════════════════════════
   PRACTICE TESTS - USER ENDPOINTS
══════════════════════════════════════════════════════════════ */

export const getPracticeTests = async (params = {}) => {
  const { data } = await api.get('/practice-tests', { params });
  return data;
};

export const getPracticeTest = async (id) => {
  const { data } = await api.get(`/practice-tests/${id}`);
  return data;
};

export const getTestProgress = async (id) => {
  const { data } = await api.get(`/practice-tests/${id}/progress`);
  return data;
};

export const startTest = async (id) => {
  const { data } = await api.post(`/practice-tests/${id}/start`);
  return data;
};

export const submitTest = async (id, body) => {
  const { data } = await api.post(`/practice-tests/${id}/submit`, body);
  return data;
};

export const getUserTestHistory = async (params = {}) => {
  const { data } = await api.get('/practice-tests/attempts/history', { params });
  return data;
};

export const getAttemptDetails = async (attemptId) => {
  const { data } = await api.get(`/practice-tests/attempts/${attemptId}`);
  return data;
};

/* ══════════════════════════════════════════════════════════════
   PRACTICE TESTS - ADMIN ENDPOINTS
══════════════════════════════════════════════════════════════ */

export const adminGetPracticeTests = async (params = {}) => {
  const { data } = await api.get('/admin/practice-tests', { params });
  return data;
};

export const adminCreatePracticeTest = async (body) => {
  const { data } = await api.post('/admin/practice-tests', body);
  return data;
};

export const adminUpdatePracticeTest = async (id, body) => {
  const { data } = await api.put(`/admin/practice-tests/${id}`, body);
  return data;
};

export const adminDeletePracticeTest = async (id) => {
  const { data } = await api.delete(`/admin/practice-tests/${id}`);
  return data;
};

export const adminGetTestAttempts = async (id, params = {}) => {
  const { data } = await api.get(`/admin/practice-tests/${id}/attempts`, { params });
  return data;
};
